import { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Subtitle1 } from '@src/elements/typography/typography'
import { ActiveTrainingWorkout } from '@src/routes/members/components/active-trainings-workouts/active-section/active-training-workout'
import { Spacer } from '@src/elements/spacer/spacer'
import { Button, MenuButton } from '@src/elements/button/button'
import { ActivateWorkouts } from '@src/routes/members/components/active-trainings-workouts/active-section/activate-workouts'
import { ActivateTrainingPlans } from '@src/routes/members/components/active-trainings-workouts/active-section/activate-training-plans'
import { ActiveTrainingsWorkouts } from '@src/routes/members/components/active-trainings-workouts/active-trainings-workouts'
import { WorkoutCardInfo } from '@src/components/card/workout-card/workout-card-info/workout-card-info'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { TrainingCardInfo } from '@src/components/card/training-card/training-card-info/training-card-info'
import { WorkoutType } from '@src/data/workout-data'
import { API } from '@src/lib/api_path'
import Checkup from '@src/data/checkup'
import { snakecaseKeys } from '@src/util/functions'
import ApiClient from '@src/lib/api_client'
import SessionManager from '@src/lib/session_manager'

@Component({
  computed: {
    member () {
      return this.$store.state.selectedMember
    },
    checkup () {
      return this.$store.state.checkup
    }
  }
})
export class WizardTrainings extends ActiveTrainingsWorkouts {

  @Prop({ required: false, default: false })
  isReadonly: boolean

  protected apiClient: ApiClient

  private checkup: Checkup

  constructor () {
    super()
    this.apiClient = new ApiClient()
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('MEMBERS')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.CHECKUPS')}`
  }

  beforeMount () {
    this.$store.dispatch('setMemberForActiveTraining', this.member)
  }

  render (h: CreateElement) {
    return <div class='active-trainings-workouts'>
      {!SessionManager.Instance.isAssistant() ? <MenuButton class='workout-btn'>
        <Button slot='button' label={this.$t('NEW')} type='elevated' />
        <Popover>
          <OptionGroup>
            <div onClick={() => {
              this.goToWorkoutBuilder(WorkoutType.CUSTOM)
            }}>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_STATION_WORKOUT')}</div>
            <div onClick={this.goToTrainingPlanBuilder}>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_TRAINING_PLAN')}</div>
          </OptionGroup>
        </Popover>
      </MenuButton> : null}
      <Subtitle1 class='active-title'>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_STATION_WORKOUT')}</Subtitle1>
      <ActiveTrainingWorkout title='PAGE.MEMBERS.TRAINING.SET_ACTIVE_WORKOUT'
                             noSelectionPlaceholder='PAGE.MEMBERS.TRAINING.NO_WORKOUT'
                             content={<ActivateWorkouts type='custom' />}
                             activeItem={this.member.activeWorkout ? <WorkoutCardInfo workout={this.member.activeWorkout} member={this.member} type='active' readonly={this.isReadonly} /> : null}
                             type='custom' />
      {this.member.activeWorkout ?
        <div class='active-workout-button-wrapper'>
        <Button class='change-workout' type='elevated' label={this.$t('PAGE.MEMBERS.TRAINING.CHANGE_WORKOUT')} click={
          () => this.changeSelection('custom', this.member.activeWorkout!)} /> </div> :
        ''}
      <Spacer />
      <Spacer />

      <Subtitle1 class='active-title'> {this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_TRAINING_PLAN')}</Subtitle1>
      <ActiveTrainingWorkout title='PAGE.MEMBERS.TRAINING.SET_ACTIVE_TRAINING_PLAN'
                             noSelectionPlaceholder='PAGE.MEMBERS.TRAINING.NO_TRAINING_PLAN'
                             content={<ActivateTrainingPlans />}
                             activeItem={this.member.currentTrainingPlan ? <TrainingCardInfo training={this.member.currentTrainingPlan} type='active' /> : null}
                             type='training-plan'
                             class='active-training-plan-wrapper' />
      {this.member.currentTrainingPlan ?
        <div class='active-workout-button-wrapper'>
          <Button class='change-workout' type='elevated' label={this.$t('PAGE.MEMBERS.TRAINING.CHANGE_PLAN')} click={
            () => this.changeSelection('training-plan', this.member.currentTrainingPlan!)} />
        </div> : ''}
      <Spacer />
    </div>
  }

  beforeDestroy () {
    if (!this.isReadonly) {
      return this.updateCheckup()
    }
  }

  private async updateCheckup () {
    let checkup = new Checkup(this.checkup)
    checkup.workoutAdded = true
    checkup.trainingPlanAdded = true
    checkup.updateState()
    this.$store.dispatch('setCheckup', checkup)

    await this.apiClient.put(`${API.TRAINERS_API.CHECKUPS.replace('{memberId}', this.member.id.toString())}/${checkup.id}`, { checkup: snakecaseKeys(checkup) })
      .catch(err => console.error('Failed to update checkup, ', err))
  }
}
